import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class compraService {
    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excelDetallado(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra/excelDetallado?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdfDetallado(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra/pdfDetallado?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}logistica/compra/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async importarRetencion(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra/importar-compras?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarClasificacion() {
        const response = await axios
            .get(`${ERP}logistica/compra`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarPorEstado(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra/listar-por-estado?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    /******* TRANSACCIONES ******/

    async registrarVinculo(data) {
        const response = await axios
            .post(`${ERP}logistica/compra/vinculo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async registrar(data) {
        const response = await axios
            .post(`${ERP}logistica/compra`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {

        const response = await axios
            .put(`${ERP}logistica/compra`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async anular(data) {
        const response = await axios
            .put(`${ERP}logistica/compra/anular`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async aprobar(data) {
        const response = await axios
            .put(`${ERP}logistica/compra/aprobar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

}

export default new compraService();